function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m29 19.001h-2.999v-5.001c0-.55-.449-1-.999-1h-3.001c-.55 0-1 .45-1 1v5.001h-2v-2.997c0-.552-.451-1.004-1.003-1.004h-2.993c-.552 0-1.004.452-1.004 1.004v2.997h-3.001c-.553 0-1 .447-1 1s.447 1 1 1h3.001v2.996c0 .552.452 1.003 1.004 1.003h2.993c.552 0 1.003-.451 1.003-1.003v-2.996h2v5c0 .55.45.999 1 .999h3.001c.55 0 .999-.449.999-.999v-5h2.999c.553 0 1-.447 1-1s-.447-1-1-1",
  fillRule: "evenodd",
  transform: "translate(-10 -13)"
});

var SvgAlignVCenter = function SvgAlignVCenter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    viewBox: "0 0 20 14",
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlignVCenter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/align-v-center.c7f6a87b.svg";
export { ForwardRef as ReactComponent };